module.exports = __webpack_public_path__ + "static/media/olho.acd41ceb.svg";